<template>
<div>
    <div class="word_2" ref="previewDom">
    <div class="a4">
      <h1 style="font-size:34px;margin-top:200px">_______（年度）建筑与市政工程</h1>
      <h1 style="font-size:34px">绿色施工评价申报表</h1>
      <h1 style="font-size:24px;margin-top:200px;text-align:start;line-height:30px">绿色施工工程名称：{{ alldata.info.msg1 }}</h1>
     <h1  style="font-size:24px;margin-top:40px;text-align:start;line-height:30px;margin-top:100px"
      >绿色施工工程承建单位（公章）：{{ alldata.info.msg7 }}</h1>
      <h1 style="font-size:24px;margin-top:250px;">贵州省建筑业协会</h1>
      <h1 style="font-size:24px;margin-bottom:50px">{{ chineseNumber() }}年制</h1>
    </div>
    <div class="a4">
      <div class="th">
        <div class="w_220">工程名称</div>
        <div class="w_380" id="condition" style="display:flex;align-items:center;justify-content:center">{{ alldata.info.msg1 }}</div>
      </div>
      <div class="th">
        <div class="w_60">建设规模和分类</div>
        <div class="w_300">
          <span style="font-size:14px;" v-if="!alldata.info.msg2">（注：规模和分类参照省优质工程要求填写）</span>
          <p  id="condition">{{ alldata.info.msg2 }}</p>
        </div>
        <div class="w_120">计划开工、竣工日期</div>
        <div class="w_120">{{ alldata.info.msg3 }} {{ alldata.info.msg4 }}</div>
      </div>
      <div class="th">
        <div class="td" style="width:140px">结构型式</div>
        <div class="long" id="condition" style="width:558px">{{ alldata.info.msg5 }}</div>
      </div>

      <!-- <div class="th">
        <div class="td">结构型式</div>
        <div class="long" <a href=""></a>id="condition">{{ alldata.info.msg5 }}</div>
       <div class="td">工程所在地</div>
        <div class="td" id="condition">{{ alldata.info.msg6 }}</div>
      </div> -->
      <!-- <div class="th">
        <div class="td">联系人</div>
        <div class="td t_w180" style="width:340px" i>{{ alldata.info.linker }}</div>
        <div class="td">联系电话</div>
        <div class="td">{{ alldata.info.tel }}</div>
      </div> -->
      <div class="th">
        <div class="td" style="width:140px">承建单位名称</div>
        <div class="long" id="condition" style="width:558px">{{ alldata.info.msg7 }}</div>
      </div>
      <div class="th">
        <div class="td" style="width:140px">建设单位名称</div>
        <div class="long" id="condition" style="width:558px">{{ alldata.info.msg8 }}</div>
      </div>
      <div class="th">
        <div class="td" style="width:140px">设计单位名称</div>
        <div class="long" id="condition" style="width:558px">{{ alldata.info.msg9 }}</div>
      </div>
      <div style="display:flex">
        <div>
          <div class="th">
            <div class="w_220" style="height:60px;">工程项目经理姓名、职务、电话</div>
            <div class="w_120" id="condition" style="width:260px;height:60px">{{ alldata.info.msg11 }}、{{ alldata.info.msg12 }}、{{ alldata.info.msg13 }}</div>
          </div>
          <div class="th">
            <div class="w_220" style="height:60px;">工程项目技术负责人姓名、职务、电话</div>
            <div class="w_120" id="condition" style="width:260px;height:60px">{{ alldata.info.msg14 }}、{{ alldata.info.msg15 }}、{{ alldata.info.msg16 }}</div>
          </div>
        </div>
        <div class="w_120" style="width:110px;height:120px">详细项目所在地</div>
        <div class="w_120" id="condition" style="width:110px;height:120px">{{ alldata.info.msg10 }}</div>
      </div>
      <div class="th">
        <div class="w_220" style="height:100px;">工程所在承建单位联系人姓名、职务、电话</div>
        <div class="w_120" id="condition" style="width:478px;height:100px">{{ alldata.info.msg17 }}、{{ alldata.info.msg18 }}、{{ alldata.info.msg19 }}</div>
      </div>
      <div class="th">
        <div class="w_597" style="font-weight: bolder;padding:10px 0">工程概况（限800字，强调重点难点）</div>
      </div>
      <div class="th">
        <div class="w_597" id="condition" style="min-height:400px;word-wrap: break-word;">{{ alldata.ProjectOverview.msg1 }}</div>
      </div>
    </div>
    <div class="a4">
      <div class="th">
        <div class="w_597" style="font-weight: bolder;padding:10px 0">拟完成绿色施工主要指标情况</div>
      </div>
      <div class="th">
        <div class="w_60" style="width:120px;display:flex;justify-content:center;height:200px">环境保护</div>
        <div class="w_540" id="condition">{{ alldata.Indicators.msg1 }}</div>
      </div>
      <div class="th">
        <div class="w_60" style="width:120px;height:200px">资源节约</div>
        <div class="w_540" id="condition">{{ alldata.Indicators.msg2 }}</div>
      </div>
      <div class="th">
        <div class="w_60" style="width:120px;height:200px">人力资源节约和保护</div>
        <div class="w_540" id="condition">{{ alldata.Indicators.msg3 }}</div>
      </div>
      <div class="th">
        <div class="w_60" style="width:120px;height:200px">技术创新</div>
        <div class="w_540" id="condition">{{ alldata.Indicators.msg4 }}</div>
      </div>
     <!-- <div class="th">
        <div class="w_60" style="width:120px;height:200px">节地与土地资源保护</div>
        <div class="w_540" id="condition">{{ alldata.Indicators.msg5 }}</div>
      </div> -->
    </div>
    <div class="a4">
      <div class="th">
        <div
          class="w_597"
          style="min-height:210px;text-align:start"
          id="condition"
        >拟组织绿色施工技术攻关和创新的项目及内容（限1000字）：<br/>
         {{ alldata.Indicators.msg6 }}
        </div>
      </div>
      <div class="th">
        <div class="w_597" id="condition" style="min-height:210px;text-align:start">工程进度情况：<br/>
        {{ alldata.Indicators.msg7 }}
        </div>
      </div>
      <div class="th">
        <div class="w_597" id="condition" style="min-height:210px;text-align:start">预期经济效益、社会效益、生态效益：<br/>
        {{ alldata.Indicators.msg8 }}
        </div>
      </div>
      <div class="th">
        <div
          class="w_597"
          style="min-height:210px;text-align:start;position: relative;"
        >
          绿色施工承建单位意见：
          <div style="position: absolute;bottom:10px;right:20px">
            <p>（公章）</p>
            <p>年 月 日</p>
          </div>
        </div>
      </div>
      <div class="th">
        <div
          class="w_597"
          style="min-height:210px;text-align:start;position: relative;"
        >
          申报单位的主管部门推荐意见：
          <div style="position: absolute;bottom:10px;right:20px">
            <p>（公章）</p>
            <p>年 月 日</p>
          </div>
        </div>
      </div>
    </div>
    </div>
    <div class="a4 viewpdf">
      <div class="th">
        <div class="w_60" style="width:50%;height:100px">绿色施工专项方案</div>
        <div class="w_60" style="width:50%;height:100px">建筑与市政工程绿色施工评价申报表</div>
      </div>
      <div class="th">
        <div class="w_60" style="width:50%;height:100px;justify-content:center">
          <a v-if="alldata.Upload.GreenConstruction.length>0" :href="alldata.Upload.GreenConstruction[0].url">有</a>
        </div>
        <div class="w_60" style="width:50%;height:100px;justify-content:center">
          <a v-if="alldata.Upload.GreenDeclarationForm.length>0" :href="alldata.Upload.GreenDeclarationForm[0].url">有</a>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import self_adaption from './adaption.js'
export default {
    props: {
      alldata: {
        type: Object,
        default: {},
        year:""
      },
  },
  data() {
    return {

    };
  },
  created() {
    let nowyaer = new Date().getFullYear()
    this.year = nowyaer
  },
  mounted() {
    this.$emit('previewDom',this.$refs.previewDom)
    self_adaption()
  },
  methods:{
    chineseNumber(){
      let num = ['0','一','二','三','四','五','六','七','八','九']
      let year = new Date().getFullYear().toString()
      let bigyear = '';
      for (let i = 0; i < year.length; i++) {
        bigyear += num[year[i]]
      }
      return bigyear
    }
  }
};
</script>

<style lang="less" scoped>
.word_2{
  width: 841px;
  margin: 0 auto;
}
.a4 {
  padding: 50px 60px 50px 60px;
  width: 842px;
  margin: 0 auto;
  margin-top: 32px;
  background: #ffffff;
  box-sizing: border-box;
  color: black;
  p,
  h1 {
    font-family: "仿宋";
  }
  .th {
    display: flex;
    align-items: center;
    font-family: "仿宋";
    font-size: 20px;
    text-align:left;
    .td {
      width: 120px;
      height: 40px;
      box-sizing: border-box;
      border: 1px solid black;
      margin: 0 -1px -1px 0;
      text-align: left;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .t_w180 {
      width: 280px;
    }
    .long {
      width: 120px * 4px-2px;
      height: 40px;
      margin: 0 -1px -1px 0;
      border: 1px solid black;
      box-sizing: border-box;
    }
  }
  .w_597 {
    width: 697px;
    border: 1px solid black;
    margin: 0 -1px -1px 0;
    box-sizing: border-box;
  }
  .w_60 {
    width: 120px;
    height: 200px;
    border: 1px solid black;
    margin: 0 -1px -1px 0;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  .w_540 {
    width: 640px-60px-2px;
    height: 200px;
    border: 1px solid black;
    margin: 0 -1px -1px 0;
    box-sizing: border-box;
    word-wrap: break-word;
  }
  .w_220,
  .w_60,
  .w_380,
  .w_300,
  .w_120 {
    height: 40px;
    border: 1px solid black;
    margin: 0 -1px -1px 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align:left;
    padding:5px;
  }
  .w_220 {
    width: 220px;
  }
  .w_380 {
    width: 480px-2px;
  }
  .w_60 {
    height: 200px;
    width: 60px;
  }
  .w_300 {
    width: 400px;
    height: 200px;
  }
  .w_120 {
    height: 200px;
    width: 120px;
    display: flex;
    align-items: center;
  }
}
.viewpdf{
  height: auto;
}
</style>
